import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';

export default function MobileTopBar({ onMenuClick }) {
  const { itemCount } = useCart();
  const navigate = useNavigate();

  return (
    <header className="md:hidden sticky top-0 z-40 bg-gradient-to-r from-brand-dark via-brand to-brand-glow shadow-card safe-top">
      <div className="h-14 px-4 flex items-center gap-3">
        <button
          type="button"
          onClick={onMenuClick}
          aria-label="Menu"
          className="h-9 w-9 -ml-1.5 rounded-full flex items-center justify-center text-white"
        >
          <span className="text-xl leading-none">☰</span>
        </button>
        <Link to="/" className="flex items-center gap-2 flex-1 min-w-0">
          <img src="/logo.jpeg" alt="NRK Mart" className="h-8 w-8 rounded-xl object-cover shadow-soft ring-2 ring-white/40" />
          <span className="font-black text-white truncate">NRK Mart</span>
        </Link>
        <button
          type="button"
          onClick={() => navigate('/cart')}
          aria-label="Cart"
          className="relative h-9 w-9 rounded-full bg-white/15 flex items-center justify-center text-lg"
        >
          🛒
          {itemCount > 0 ? (
            <span className="absolute -top-1 -right-1 h-4 min-w-4 px-1 rounded-full bg-gold text-white text-[9px] font-black flex items-center justify-center">
              {itemCount}
            </span>
          ) : null}
        </button>
      </div>
    </header>
  );
}
